import { createFileRoute, redirect } from '@tanstack/react-router';
import { TRADE_BASE_PATH } from '../../../../../../../../features/trade/trade-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/')({
  beforeLoad: () => {
    throw redirect({ to: TRADE_BASE_PATH, replace: true });
  },
  preload: false,
});
